import React from 'react';
import OccupationalTherapyPageHeader from './occupationaltherapy/OccupationalTherapyPageHeader';
import OccupationalTherapyPageSession from './occupationaltherapy/OccupationalTherapyPageSession';

function OccupationalTherapyPage() {
  return (
    <div className="page-wrapper">
      <OccupationalTherapyPageHeader />
      <OccupationalTherapyPageSession />
    </div>
  );
}

export default OccupationalTherapyPage;
